import { render, staticRenderFns } from "./abuot.vue?vue&type=template&id=57d177bc&scoped=true&"
import script from "./abuot.vue?vue&type=script&lang=js&"
export * from "./abuot.vue?vue&type=script&lang=js&"
import style0 from "./abuot.vue?vue&type=style&index=0&id=57d177bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d177bc",
  null
  
)

export default component.exports